import { call, put, takeEvery } from 'redux-saga/effects';

import request from 'helpers/api';

import { CHECK, checked } from 'redux/reducers/giftcards';
import { setSidebar } from 'redux/reducers/app';

export function* checkGiftcard({ code }) {
  try {
    const valid = yield call(request, 'giftcards/check', {
      body: {
        code,
      },
    });

    yield put(checked(code, valid));

    if (valid) {
      yield put(setSidebar('registration'));
    }
  } catch (e) {
    pe(e);
  }
}

export default function* saga() {
  yield takeEvery(CHECK, checkGiftcard);
}



// WEBPACK FOOTER //
// ./app/redux/sagas/giftcards.js